module.exports = __webpack_public_path__ + "static/media/Thirsk-Carved-Font-by-TTF.4562063f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Thirsk-Carved-Font-by-TTF.otf
// module id = 3800
// module chunks = 70